import { useSessionContext } from "supertokens-auth-react/recipe/session";

export function GetUserId() {
  const session = useSessionContext();
  return session.userId;
}
